export const VARIABLE_PATTERN = /{{\s*(.*?)\s*}}/;
export const VARIABLE_PATTERN_GLOBAL = /{{\s*(.*?)\s*}}/g;
export function extractVariableName(content) {
    if (!content) {
        return '';
    }
    const match = VARIABLE_PATTERN.exec(content);
    return match?.[1]?.trim() || '';
}
export function formatVariable(variableName) {
    return `{{${variableName}}}`;
}
